/* eslint-disable camelcase, @typescript-eslint/naming-convention -- mirrors the Rails JSON contract */
import React from 'react';
import { translate } from '@utils/i18n';
import { Text } from '@ui';
import { ChartView } from '@ui/molecules/ChartView';
import { FeaturedRuleTrendFlagItem } from './FeaturedRuleTrendFlagItem';
import { RulesTrendFlagItem } from './RulesTrendFlagItem';
const NS = 'features.iim_review.tech_performance_drawer';
/** Builds the duration line chart. `inspections` arrive newest-first; the chart plots oldest-first. */
export function buildDurationTrendChartBlock(inspections) {
    const chronological = [...inspections].reverse();
    return {
        type: 'chart',
        block_id: 'tech-performance-duration-trend',
        block_index: 0,
        chart_type: 'line',
        data: {
            labels: chronological.map((row) => row.date),
            datasets: [
                {
                    label: translate('duration_series_label', { namespace: NS, defaultValue: 'Duration (minutes)' }),
                    data: chronological.map((row) => row.duration_minutes)
                }
            ]
        },
        options: { show_legend: false, show_values: false, y_axis_label: 'Minutes' }
    };
}
export function TrendSection({ trend, buildingMedianDurationMinutes, thisInspectionRuleFindingsCount, buildingMedianRuleFindingsPerInspection, featuredRuleFinding }) {
    if (trend.inspections.length === 0)
        return null;
    return (React.createElement("section", { className: "tech-performance-drawer__section" },
        React.createElement(Text, { variant: "x-small", as: "h4", className: "tech-performance-drawer__section-title" }, trend.window_description),
        React.createElement(ChartView, { block: buildDurationTrendChartBlock(trend.inspections) }),
        buildingMedianDurationMinutes != null && (React.createElement(Text, { variant: "x-small", as: "p", className: "tech-performance-drawer__trend-footnote" }, translate('trend_footnote', {
            namespace: NS,
            count: buildingMedianDurationMinutes,
            defaultValue: 'Building median for this inspection type is %{count} minutes.'
        }))),
        React.createElement("ul", { className: "tech-performance-drawer__flags" },
            React.createElement(RulesTrendFlagItem, { trend: trend, thisInspectionRuleFindingsCount: thisInspectionRuleFindingsCount, buildingMedianRuleFindingsPerInspection: buildingMedianRuleFindingsPerInspection }),
            featuredRuleFinding && trend.featured_rule_finding_trend && (React.createElement(FeaturedRuleTrendFlagItem, { featuredRuleFinding: featuredRuleFinding, featuredRuleFindingTrend: trend.featured_rule_finding_trend })))));
}
